export const refs = {
  searchForm: document.querySelector('.js-search-form'),
  formWarning: document.querySelector('.header-form__warning'),
  cardsListEl: document.querySelector('.cards__list'),
  backdrop: document.querySelector('.backdrop'),
  closeModalBtn: document.querySelector('.btn-close'),

  trailerBtn: document.querySelector('[data-modal-trailer]'),

  openTrailerFilm: null,
  watchedBtn: null,
  queueBtn: null,
};
